import createIcon from '../../createIcon';

/**
 * @component @name Cabin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMkMxMCAzLjY2IDguNjYgNSA3IDVDNi40NSA1IDYgNS40NSA2IDZINEM0IDQuMzQgNS4zNCAzIDcgM0M3LjU1IDMgOCAyLjU1IDggMkgxMFpNMTIgNEw2IDguNThWN0g0VjEwLjExTDEgMTIuNEwyLjIxIDEzLjk5TDQgMTIuNjJWMjJIMjBWMTIuNjJMMjEuNzkgMTMuOThMMjMgMTIuNEwxMiA0Wk0xMy45NCA4SDEwLjA1TDEyIDYuNTJMMTMuOTQgOFpNNy40NCAxMEgxNi41NkwxOCAxMS4xVjEySDZWMTEuMUw3LjQ0IDEwWk0xOCAxNFYxNkg2VjE0SDE4Wk02IDIwVjE4SDE4VjIwSDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cabin = createIcon('Cabin', [
  [
    'path',
    {
      d: 'M10 2C10 3.66 8.66 5 7 5C6.45 5 6 5.45 6 6H4C4 4.34 5.34 3 7 3C7.55 3 8 2.55 8 2H10ZM12 4L6 8.58V7H4V10.11L1 12.4L2.21 13.99L4 12.62V22H20V12.62L21.79 13.98L23 12.4L12 4ZM13.94 8H10.05L12 6.52L13.94 8ZM7.44 10H16.56L18 11.1V12H6V11.1L7.44 10ZM18 14V16H6V14H18ZM6 20V18H18V20H6Z',
      key: '1yu0ut',
    },
  ],
]);

export default Cabin;
